// extracted by mini-css-extract-plugin
export default {"backToTop":"backtottop_backToTop__L4glp","icon":"backtottop_icon__weY3M"};